import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-discovery",
  "use": "icon-discovery-usage",
  "viewBox": "0 0 40 40",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 40 40\" id=\"icon-discovery\"><path d=\"M22.9948672,20.8735468 L24.6085518,15.3914588 L19.1264586,17.0051382 L22.9948672,20.8735468 Z M20.8735414,22.9948618 L17.0051328,19.1264532 L15.3914482,24.6085412 L20.8735414,22.9948618 Z M20,39 C9.50658975,39 1,30.4934102 1,20 C1,9.50658975 9.50658975,1 20,1 C30.4934102,1 39,9.50658975 39,20 C39,30.4934102 30.4934102,39 20,39 Z M20,36 C28.836556,36 36,28.836556 36,20 C36,11.163444 28.836556,4 20,4 C11.163444,4 4,11.163444 4,20 C4,28.836556 11.163444,36 20,36 Z M28.9876747,11.1385984 L24.9285291,24.9285249 L11.1385832,28.9876591 C11.0943257,29.0131319 11.0377982,28.997904 11.0123253,28.9536467 C10.9958916,28.9250941 10.9958916,28.8899542 11.0123253,28.8614016 L15.0714709,15.0714751 L28.8614168,11.0123409 C28.9056743,10.9868681 28.9622018,11.002096 28.9876747,11.0463533 C29.0041084,11.0749059 29.0041084,11.1100458 28.9876747,11.1385984 Z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/discovery.svg
// module id = YUbZ
// module chunks = 28